import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-stock-table-skeleton',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg overflow-hidden animate-pulse">
      <div class="overflow-x-auto">
        <table class="w-full">
          <!-- Skeleton Header -->
          <thead class="bg-gray-50 dark:bg-gray-700">
            <tr>
              <th class="px-6 py-4">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-20"></div>
              </th>
              <th class="px-6 py-4">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-24"></div>
              </th>
              <th class="px-6 py-4">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-20"></div>
              </th>
              <th class="px-6 py-4">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-20"></div>
              </th>
              <th class="px-6 py-4">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-16"></div>
              </th>
              <th colspan="5" class="px-6 py-4">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-32"></div>
              </th>
            </tr>
          </thead>

          <!-- Skeleton Body -->
          <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
            <tr *ngFor="let item of skeletonRows(); trackBy: trackByIndex" class="hover:bg-gray-50 dark:hover:bg-gray-700">
              <!-- Company Column -->
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="flex items-center space-x-3">
                  <div class="h-8 w-8 bg-gray-200 dark:bg-gray-600 rounded-full"></div>
                  <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-24"></div>
                </div>
              </td>

              <!-- Price Columns -->
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-16"></div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-16"></div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-16"></div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-20"></div>
              </td>

              <!-- Growth Metrics -->
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-12"></div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-12"></div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-12"></div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-12"></div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-12"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `,
  styles: [`
    .animate-pulse {
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }

    @keyframes pulse {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: .5;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StockTableSkeletonComponent {
  // Input for number of skeleton rows to display
  rows = input<number>(5);

  // Computed signal for skeleton rows array
  skeletonRows = () => Array.from({ length: this.rows() }, (_, i) => i);

  // TrackBy function for performance
  trackByIndex(index: number): number {
    return index;
  }
}
